
import { defineComponent } from "vue";

export default defineComponent({
	name: "Separator",
	props: {
		color: String,
	},
});
